import { render, staticRenderFns } from "./mainFeedCategories.vue?vue&type=template&id=8aa1d5e4"
import script from "./mainFeedCategories.component.js?vue&type=script&lang=js&external"
export * from "./mainFeedCategories.component.js?vue&type=script&lang=js&external"
import style0 from "./mainFeedCategories.vue?vue&type=style&index=0&id=8aa1d5e4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCombobox } from 'vuetify/lib/components/VCombobox';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VBtn,VCombobox,VDataTable,VDialog,VIcon,VImg,VList,VListItem,VListItemTitle,VMenu,VSwitch})
